import { SearchContext } from "app/SearchContext";
import useTogglePlayer from "core/customHooks/useTogglePlayer";
import { Result, content, graphql } from "core/utils";
import React, { useContext } from "react";
import { QUERY as searchQuery } from "search/QUERY";
import { View as Search } from "search/View";
var getData = function (term) {
    var _a = graphql.useLazyQueryWithResult(searchQuery, {
        variables: {
            term: term,
        },
        fetchPolicy: "cache-and-network",
    }), query = _a[0], _b = _a[1], loading = _b.loading, error = _b.error, result = _b.data;
    if (loading)
        return [query, Result.loading];
    if (error)
        return [query, Result.fail(content.search.page.errorMessage)];
    if (result === undefined)
        return [query, null];
    return [query, Result.success(result.getSearchResults.components)];
};
export var Provider = function () {
    var _a = getData(), getSearchResults = _a[0], result = _a[1];
    var showSearch = useContext(SearchContext).showSearch;
    useTogglePlayer(showSearch);
    return (React.createElement(Search, { search: function (term) {
            getSearchResults({
                variables: { term: term },
                fetchPolicy: "cache-and-network",
            });
        }, result: result }));
};
